import type { ReactNode } from 'react';

import { SearchResultsBodyHolder } from './SearchResultsBody.styled';

type Props = {
  children: ReactNode;
};

export function SearchResultsBody({ children }: Props) {
  return (
    <SearchResultsBodyHolder data-qa-id="search-results">
      {children}
    </SearchResultsBodyHolder>
  );
}
